import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGlobalStore = defineStore('global', () => {
  // state
  const languagesLoaded = ref(false);

  // actions
  function setLocaleLoaded(loaded: boolean) {
    languagesLoaded.value = loaded;
  }

  function $reset() {
    languagesLoaded.value = false;
  }

  return { languagesLoaded, setLocaleLoaded, $reset };
});
